import { Controller } from "@hotwired/stimulus";
import kendo from "kendo-ui-core";

const $ = kendo.jQuery;
const bibleBooks = [
  // Old Testament
  {name: "Genesis", chapters: 50},
  {name: "Exodus", chapters: 40},
  {name: "Leviticus", chapters: 27},
  {name: "Numbers", chapters: 36},
  {name: "Deuteronomy", chapters: 34},
  {name: "Joshua", chapters: 24},
  {name: "Judges", chapters: 21},
  {name: "Ruth", chapters: 4},
  {name: "1 Samuel", chapters: 31},
  {name: "2 Samuel", chapters: 24},
  {name: "1 Kings", chapters: 22},
  {name: "2 Kings", chapters: 25},
  {name: "1 Chronicles", chapters: 29},
  {name: "2 Chronicles", chapters: 36},
  {name: "Ezra", chapters: 10},
  {name: "Nehemiah", chapters: 13},
  {name: "Esther", chapters: 10},
  {name: "Job", chapters: 42},
  {name: "Psalm", chapters: 150},
  {name: "Proverbs", chapters: 31},
  {name: "Ecclesiastes", chapters: 12},
  {name: "Song of Solomon", chapters: 8},
  {name: "Isaiah", chapters: 66},
  {name: "Jeremiah", chapters: 52},
  {name: "Lamentations", chapters: 5},
  {name: "Ezekiel", chapters: 48},
  {name: "Daniel", chapters: 12},
  {name: "Hosea", chapters: 14},
  {name: "Joel", chapters: 3},
  {name: "Amos", chapters: 9},
  {name: "Obadiah", chapters: 1},
  {name: "Jonah", chapters: 4},
  {name: "Micah", chapters: 7},
  {name: "Nahum", chapters: 3},
  {name: "Habakkuk", chapters: 3},
  {name: "Zephaniah", chapters: 3},
  {name: "Haggai", chapters: 2},
  {name: "Zechariah", chapters: 14},
  {name: "Malachi", chapters: 4},

  // New Testament
  {name: "Matthew", chapters: 28},
  {name: "Mark", chapters: 16},
  {name: "Luke", chapters: 24},
  {name: "John", chapters: 21},
  {name: "Acts", chapters: 28},
  {name: "Romans", chapters: 16},
  {name: "1 Corinthians", chapters: 16},
  {name: "2 Corinthians", chapters: 13},
  {name: "Galatians", chapters: 6},
  {name: "Ephesians", chapters: 6},
  {name: "Philippians", chapters: 4},
  {name: "Colossians", chapters: 4},
  {name: "1 Thessalonians", chapters: 5},
  {name: "2 Thessalonians", chapters: 3},
  {name: "1 Timothy", chapters: 6},
  {name: "2 Timothy", chapters: 4},
  {name: "Titus", chapters: 3},
  {name: "Philemon", chapters: 1},
  {name: "Hebrews", chapters: 13},
  {name: "James", chapters: 5},
  {name: "1 Peter", chapters: 5},
  {name: "2 Peter", chapters: 3},
  {name: "1 John", chapters: 5},
  {name: "2 John", chapters: 1},
  {name: "3 John", chapters: 1},
  {name: "Jude", chapters: 1},
  {name: "Revelation", chapters: 22},
];

export default class extends Controller {
  static values = {
  };

  static targets = [
    "bookField",
    "chapterField",
  ];

  connect() {
    var that = this;

    // Set up chapter field
    var chapterField = $(this.chapterFieldTarget);
    var currentChapter = chapterField.data("current-value");
    chapterField.kendoComboBox({
      filter: "startsWith",
      dataSource: [1],
      enable: false,
    });

    // Set up event callbacks for book
    var bookField = $(this.bookFieldTarget);
    var currentBook = bookField.data("current-value");
    bookField.kendoComboBox({
      filter: "contains",
      dataSource: bibleBooks,
      dataTextField: "name",
      dataValueField: "name",
      value: currentBook,

      change: function(e) {
        var book = this.value();
        var bookItem = bibleBooks.find((bibleBook) => bibleBook.name == book);
        var chapterComboBox = $(that.chapterFieldTarget).getKendoComboBox();
        
        if (bookItem === undefined || bookItem.chapters == 1) {
          // disable the chapter field box if only one chapter or book not found
          chapterComboBox.enable(false);
          chapterComboBox.value("");
        } else {
          // enable the chapter field
          chapterComboBox.enable(true);

          // set chapter options to number based on book
          chapterComboBox.setDataSource(Array(bookItem.chapters).fill().map((_,i) => i+1));
        }
      },
    });

    // set current chapter
    chapterField.getKendoComboBox().value(currentChapter);
    if (currentChapter) chapterField.getKendoComboBox().enable(true);
  }

}